import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { CreateVenueData, Venue } from '../models/Venue'
import {
  WhatsappBotWABA,
  WhatsappBotWABAWithConfiguration,
} from '../models/WhatsappBot'
import { VENUES_URL } from '../utils/urls'

const fetchVenues = (params: TableParams) =>
  SBAPI.FetchPaginated<Venue[]>(VENUES_URL, params)

const fetchVenueBySlug = (slug: string, params?: TableParams) =>
  SBAPI.Fetch<Venue>(`${VENUES_URL}/${slug}`, params)

const fetchVenueWhatsappBotDetailsBySlug = (slug: string) =>
  SBAPI.Fetch<WhatsappBotWABAWithConfiguration>(
    `${VENUES_URL}/${slug}/whatsapp-bot`
  )

const registerVenueWhatsappBotDetailsBySlug = (slug: string, body: any) =>
  SBAPI.Post<WhatsappBotWABA>(
    `${VENUES_URL}/${slug}/whatsapp-bot/register`,
    body
  )

const createVenue = (venue: CreateVenueData) => SBAPI.Post(VENUES_URL, venue)

const updateVenue = (venue: Partial<Venue>) =>
  SBAPI.Put(`${VENUES_URL}/${venue.slug}`, venue)

const updateVenueLogo = (venue: Venue, file: File) => {
  const data = new FormData()
  data.append('file', file)
  return SBAPI.Post(`${VENUES_URL}/${venue.slug}/logo`, data)
}

const deleteVenue = (venue: Venue) =>
  SBAPI.Delete(`${VENUES_URL}/${venue.slug}`)

export {
  createVenue,
  deleteVenue,
  fetchVenueBySlug,
  fetchVenues,
  fetchVenueWhatsappBotDetailsBySlug,
  registerVenueWhatsappBotDetailsBySlug,
  updateVenue,
  updateVenueLogo,
}
